import {
  oDataTypeConfig,
  transformAssetId,
  namePropertyConfig,
} from './request-transformer-util';

export const transformRenameRequest = ({ assetId, folderAssetType, name }) => ({
  Asset: {
    '@odata.type': oDataTypeConfig[folderAssetType],
    Id: transformAssetId(assetId),
    [namePropertyConfig[folderAssetType]]: name,
  },
});

export const transformAltTextRequest = ({ assetId, folderAssetType, text }) => ({
  Asset: {
    '@odata.type': oDataTypeConfig[folderAssetType],
    Id: transformAssetId(assetId),
    AltText: text,
  },
});
